import { render, staticRenderFns } from "./HuchaListadoAportacionesSkeleton.vue?vue&type=template&id=0a21cd76&scoped=true"
import script from "./HuchaListadoAportacionesSkeleton.vue?vue&type=script&lang=js"
export * from "./HuchaListadoAportacionesSkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a21cd76",
  null
  
)

export default component.exports